<template>
    <div class="bg-warning rounded p-3 mb-3">
        <!-- 우선 평가에 아직 신청 이력이 없는 경우 -->
        <template v-if="!altVendor.validated">
            <div class="text-center mb-3">
                <p class="fw-500 mb-0">
                    {{ $t('평가 신청 이력이 없습니다. 아래 "참여중인 평가 신청" 버튼을 클릭해 평가신청을 완료한 후 답변해주시기 바랍니다.') }}
                </p>
            </div>
            <div class="text-center">
                <b-btn variant="dark" @click="$emit('apply')">
                    {{ $t('참여중인 평가 신청') }}
                </b-btn>
            </div>
        </template>

        <!-- 이미 우선 평가에 참여중/완료인 경우 -->
        <template v-else>
            <div class="text-center">
                <p class="fw-400 f-95 mb-0">
                    {{ $t(assessmentTitle) }} {{ $t('신청을 해주셔서 감사합니다.') }}
                </p>
                <!-- 조각 키('귀사는'·'대상'·'이므로…')는 영어·중국어 어순이 깨져 한 문장 키로 합쳤다 -->
                <i18n path="귀사는 {title} 대상이므로 해당 평가로 대체됩니다." tag="p" class="fw-400 f-95 mb-0">
                    <template #title><b class="text-underline">{{ $t(assessmentTitle) }}</b></template>
                </i18n>
            </div>
            <hr>
            <p class="fw-400 f-95 mb-3 text-center">
                <template v-if="['requested', 'in_progress'].includes(statusCode)">
                    <b class="text-underline">{{ $t(assessmentTitle) }}</b>{{ $t('가 아직 \'답변중\' 상태입니다. 해당 평가에 답변을 제출해 주셔야 참여 완료로 처리됩니다.') }}
                </template>
                <template v-else-if="statusCode === 'in_assessment'">
                    {{ $t('현재, 제출 완료된 답변을 평가중입니다. 해당 답변 평가가 완료된 후 자동으로 완료 처리됩니다.') }}
                </template>
                <template v-else-if="statusCode === 'completed'">
                    {{ $t('제출한 평가가 완료되었습니다. 해당 평가 결과로 대체될 예정입니다.') }}
                </template>
                <template v-else>
                    {{ $t('평가 신청 이력이 없습니다. 아래 "참여중인 평가 신청" 버튼을 클릭해 평가신청을 완료한 후 답변해주시기 바랍니다.') }}
                </template>
            </p>

            <b-table-simple v-if="altVendor.request_info" responsive bordered table-class="bg-light mb-0">
                <b-thead>
                    <b-tr>
                        <b-th>{{ $t('참여중인 평가') }}</b-th>
                        <b-th>{{ $t('업체코드') }}</b-th>
                        <b-th><div class="text-nowrap">{{ $t('평가 신청일') }}</div></b-th>
                        <b-th>{{ $t('평가 관리자 정보') }}</b-th>
                        <b-th>{{ $t('참여 상태') }}</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-td>{{ $t(assessmentTitle) }}</b-td>
                        <b-td>{{ altVendor.vendor_code }}</b-td>
                        <b-td>
                            <div class="text-nowrap">
                                {{ altVendor.request_info.requested_ts ? altVendor.request_info.requested_ts.split('T')[0] : ' - ' }}
                            </div>
                        </b-td>
                        <b-td>
                            <template v-if="altVendor.manager">
                                <div>{{ altVendor.manager.user_name }}</div>
                                <div>({{ altVendor.manager.e_mail }})</div>
                            </template>
                            <template v-else> - </template>
                        </b-td>
                        <b-td>{{ $t(statusLabel) }}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </template>
    </div>
</template>

<script>
// priority_vendor_code 대체(우선)평가 안내 — custom hmc-theme/hyundai-v2 모놀리스의
// assessment_alt 분기를 신세대 트리 위에 공용화한 것 (2026-09-02).
// 서브도메인별 On/Off: tenant.register.priorityAssessment 테넌트에서만 마운트된다.
// 안내 문구는 ko 원문 $t 키 — en/ca 는 apps/supply/src/locales 에 있다
const STATUS_LABELS = {
    requested: '신청완료',
    in_progress: '답변중',
    in_assessment: '평가중',
    completed: '평가완료',
    canceled: '평가 취소',
};

export default {
    name: 'PriorityAssessmentNotice',
    props: {
        altVendor: {
            type: Object,
            required: true,
        },
        assessmentTitle: {
            type: String,
            default: '참여중인 평가',
        },
    },
    computed: {
        statusCode() {
            return this.altVendor.request_info && this.altVendor.request_info.status_code;
        },
        statusLabel() {
            return STATUS_LABELS[this.statusCode] || this.statusCode || ' - ';
        },
    },
};
</script>
